import {findAllIndexesM, getAfterColon, getValueByIndices, formatDate, boxCoordinate, lineCoordinate, seekPosIndex} from './utilsOCR'
var form = {}

// 发票数据集成
export function invoiceCollection(OCRObj) {
    boxCoordinate(OCRObj); // 画BOX
    form.invoiceType = findAllIndexesM(OCRObj, "专用发票") == [] ? "0" : "1"; // 发票类型
    form.isElectronic = findAllIndexesM(OCRObj, "内蒙古增值税电子") != [] ? "Y" : "N"; // 是否电子发票
    form.invoiceCode = findAllIndexesM(OCRObj, "发票号码") != [] ? getAfterColon(
        getValueByIndices(
          OCRObj,
          findAllIndexesM(OCRObj, "发票号码")[0]
        ),
        "："
      )
    : ""

    form.invoiceDate = findAllIndexesM(OCRObj, "开票日期") != []
    ? formatDate(
        getAfterColon(
          getValueByIndices(
            OCRObj,
            findAllIndexesM(OCRObj, "开票日期")[0]
          ),
          "："
        )
      )
    : ""

    form.invoiceAmount = findAllIndexesM(OCRObj, "价税合计") != []
    ? getAfterColon(
        lineCoordinate(
          getValueByIndices(
            OCRObj,
            seekPosIndex(findAllIndexesM(OCRObj, "价税合计")[0])
          )
        )[1].msg.replace("￥", "¥"),
        "¥"
      )
    : ""

    form.taxAmount = findAllIndexesM(OCRObj, "计") != []
    ? getAfterColon(
        lineCoordinate(
          getValueByIndices(
            OCRObj,
            seekPosIndex(findAllIndexesM(OCRObj, "计")[0])
          )
        )[1].msg.replace("￥", "¥"),
        "¥"
      )
    : ""

    form.taxExcludedAmount = findAllIndexesM(OCRObj, "计") != []
    ? getAfterColon(
        lineCoordinate(
          getValueByIndices(
            OCRObj,
            seekPosIndex(findAllIndexesM(OCRObj, "计")[0])
          )
        )[0].msg.replace("￥", "¥"),
        "¥"
      )
    : ""
        return form
    // this.OCRIndex = this.findAllIndexes(OCRObj, "税率")
    // console.log(
    //   getAfterColon(
    //     lineCoordinate(
    //       getValueByIndices(
    //         OCRObj,
    //         seekPosIndex(findAllIndexesM(OCRObj, "小写")[0])
    //       )
    //     )[0].msg.replace("￥", "¥"),
    //     "¥"
    //   ),
    //   "12312312"
    // );
  }